module.exports = __webpack_public_path__ + "static/media/black-cross-icon-24x24.d3d38578.svg";